import { useRentalUnitField } from '../../../../../../../../queries/useRentalUnitField';
import { NumberBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../../components/ApplicationQuestionReviewItem';
import { ShowIf } from '../../../../../../../components/ShowIf';

interface BathroomsProps {
    unitGuid: string;
    required: boolean;
    isReview?: boolean;
    showLabel?: boolean;
}

export const Bathrooms: React.FC<BathroomsProps> = ({ unitGuid, required, isReview = false, showLabel = false }) => {
    const label = 'Bathrooms';
    const [bathrooms, set_bathrooms] = useRentalUnitField(
        unitGuid,
        (u) => u.bathrooms,
        (u, v) => ({ ...u, bathrooms: v })
    );

    return (
        <>
            {isReview ? (
                <>
                    <ShowIf showIf={showLabel}>
                        <ApplicationQuestionReviewItem
                            label={label}
                            value={bathrooms}
                            showLabel={showLabel}
                        />
                    </ShowIf>
                    <ShowIf showIf={!showLabel}>{bathrooms}</ShowIf>
                </>
            ) : (
                <NumberBox
                    id={`bathrooms_${unitGuid}`}
                    value={bathrooms}
                    onChange={(value) => set_bathrooms(value)}
                    required={required}
                    label={showLabel ? label : undefined}
                />
            )}
        </>
    );
};
